import { render, staticRenderFns } from "./ManualEntryLeaderboardPaidHistory.vue?vue&type=template&id=5b3c93ff&scoped=true"
import script from "./ManualEntryLeaderboardPaidHistory.vue?vue&type=script&lang=js"
export * from "./ManualEntryLeaderboardPaidHistory.vue?vue&type=script&lang=js"
import style0 from "./ManualEntryLeaderboardPaidHistory.vue?vue&type=style&index=0&id=5b3c93ff&prod&lang=scss&scoped=true"
import style1 from "./ManualEntryLeaderboardPaidHistory.vue?vue&type=style&index=1&id=5b3c93ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c93ff",
  null
  
)

export default component.exports